<template>
	<div id="page-top">
		<!-- Page Wrapper -->
		<div id="root">
				<div class="row align-items-stretch">
					<div class="c-dashboardInfo col-lg-3 col-md-6">
						<div class="wrap" style="padding-left: 10px">
							<div class=" c-dashboardInfo__title mb-1" style="color: #00a576; font-weight: bold">Доход (Месячный)</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 mb-1 d-flex"><span class="flag-icon flag-icon-uz"/> &nbsp; &nbsp;{{ sumMonthlyUzs | currency({symbol: 'UZS', fractionCount: 2, symbolPosition: 'back'}) }}</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 d-flex"  ><span class="flag-icon flag-icon-us"/>&nbsp; &nbsp; {{ sumMonthlyUsd | currency({symbol: 'USD', fractionCount: 2, symbolPosition: 'back'}) }}</div>
						</div>
					</div>
					<div class="c-dashboardInfo col-lg-3 col-md-6">
						<div class="wrap" style="padding-left: 10px">
							<div class="c-dashboardInfo__title mb-1" style="color: #0f66c6; ">Доход (Вчерашний))</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 mb-1 d-flex"><span class="flag-icon flag-icon-uz"/> &nbsp; &nbsp;{{ sumDailyUzs | currency({symbol: 'UZS', fractionCount: 2, symbolPosition: 'back'}) }}</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 d-flex"  ><span class="flag-icon flag-icon-us"/>&nbsp; &nbsp; {{ sumDailyUsd | currency({symbol: 'USD', fractionCount: 2, symbolPosition: 'back'}) }}</div>
						</div>
					</div>
					<div class="c-dashboardInfo col-lg-3 col-md-6">
						<div class="wrap" style="padding-left: 10px">
							<div class="c-dashboardInfo__title mb-1" style="color: rgb(0 160 198);">СУММА ТЕКУЩЕГО ОСТАТКА</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 mb-1 d-flex"><span class="flag-icon flag-icon-uz"/> &nbsp; &nbsp;{{ sumRemainingUzs | currency({symbol: 'UZS', fractionCount: 2, symbolPosition: 'back'}) }}</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 d-flex"  ><span class="flag-icon flag-icon-us"/>&nbsp; &nbsp; {{ sumRemainingUsd | currency({symbol: 'USD', fractionCount: 2, symbolPosition: 'back'}) }}</div>
						</div>
					</div>
					<div class="c-dashboardInfo col-lg-3 col-md-6">
						<div class="wrap" style="padding-left: 10px">
							<div class="c-dashboardInfo__title mb-1" style="color: #585fb3">СУММА ВЧЕРАШНЕГО ПРОДАЖ</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 mb-1 d-flex"><span class="flag-icon flag-icon-uz"/> &nbsp; &nbsp;{{ sumSaleUzs | currency({symbol: 'UZS', fractionCount: 2, symbolPosition: 'back'}) }}</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800 d-flex"  ><span class="flag-icon flag-icon-us"/>&nbsp; &nbsp; {{ sumSaleUsd | currency({symbol: 'USD', fractionCount: 2, symbolPosition: 'back'}) }}</div>
						</div>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
import ReportService from "../analytics/otchot/report.service";
import HighchartsVue from "highcharts-vue";
export default {
	components:{
		HighchartsVue,
	},
	props:['monthly','daily','remaining','saleSum'],
	name: 'transaction',
	data() {
		return {

		}
	},
	computed: {
		sumMonthlyUzs() {
			let sum = 0
			this.monthly.forEach(m => {
				if (m.code && m.code=='UZS')
					sum+=m.value
			})
			return sum
		},
		sumMonthlyUsd() {
			let sum = 0
			this.monthly.forEach(m => {
				if (m.code && m.code=='USD')
					sum+=m.value
			})
			return sum
		},
		sumDailyUzs() {
			let sum = 0
			this.daily.forEach(d => {
				if (d.code && d.code=='UZS')
					sum+=d.value
			})
			return sum
		},
		sumDailyUsd() {
			let sum = 0
			this.daily.forEach(d => {
				if (d.code && d.code=='USD')
					sum+=d.value
			})
			return sum
		},
		sumRemainingUzs() {
			let sum = 0
			this.remaining.forEach(r => {
				if (r.code && r.code=='UZS')
					sum+=r.value
			})
			return sum
		},
		sumRemainingUsd() {
			let sum = 0
			this.remaining.forEach(r => {
				if (r.code && r.code=='USD')
					sum+=r.value
			})
			return sum
		},
		sumSaleUzs() {
			let sum = 0
			this.saleSum.forEach(s => {
				if (s.code && s.code=='UZS')
					sum+=s.value
			})
			return sum
		},
		sumSaleUsd() {
			let sum = 0
			this.saleSum.forEach(s => {
				if (s.code && s.code=='USD')
					sum+=s.value
			})
			return sum
		}
	},
	methods: {
	},
	async created() {

	}
}
</script>

<style scoped>
.c-dashboardInfo {
	margin-bottom: 15px;
}
.c-dashboardInfo .wrap {
	background: #ffffff;
	box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
	border-radius: 7px;
	position: relative;
	overflow: hidden;
	padding: 18px 5px 5px;
	height: 100%;
}
.c-dashboardInfo__title{
	color: #6c6c6c;
	font-size: 13px;
	font-weight: 900;
	text-align: center;
}
.c-dashboardInfo span {
	display: block;
}
.c-dashboardInfo__count {
	font-weight: bold;
	font-size: 15px;
	color: #323c43;
}
.c-dashboardInfo .wrap:after {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 10px;
	content: "";
}

.c-dashboardInfo:nth-child(1) .wrap:after {
	background: linear-gradient(82.59deg, #00c48c 0%, #00a173 100%);
}
.c-dashboardInfo:nth-child(2) .wrap:after {
	background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%);
}
.c-dashboardInfo:nth-child(3) .wrap:after {
	background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%);
}
.c-dashboardInfo:nth-child(4) .wrap:after {
	background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}
.c-dashboardInfo__title svg {
	color: #d7d7d7;
	margin-left: 5px;
}
.MuiSvgIcon-root-19 {
	fill: currentColor;
	width: 1em;
	height: 1em;
	display: inline-block;
	font-size: 24px;
	transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	user-select: none;
	flex-shrink: 0;
}

</style>

